import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'data-engine-api',
  name: 'Access Data Engine',
  category: 'access-integrations',
  description: 'Query, manage, and refresh data in Access Data Engine tables, data flows, schedules, and views',
  icon: 'Database',
  color: 'blue',
  version: '2.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_data_engine',
    description: 'Interact with Access Data Engine to query data, manage tables, run data flows, trigger schedules, and refresh views.',
    allowManualDescription: true,
    parameters: {
      resourceGroup: {
        toolParamName: 'resource_group',
        description: 'The resource type: data, bulkData, table, dataFlow, schedule, or view',
        required: true,
        type: 'string',
      },
      operation: {
        toolParamName: 'operation',
        description: 'The operation to perform (varies by resource group)',
        required: true,
        type: 'string',
      },
      tableId: {
        toolParamName: 'table_id',
        description: 'The table ID (for data, bulkData, or table operations)',
        required: false,
        type: 'string',
      },
      dataFlowId: {
        toolParamName: 'dataflow_id',
        description: 'The data flow ID (for dataFlow operations)',
        required: false,
        type: 'string',
      },
      scheduleId: {
        toolParamName: 'schedule_id',
        description: 'The schedule ID (for schedule operations)',
        required: false,
        type: 'string',
      },
      viewId: {
        toolParamName: 'view_id',
        description: 'The view ID (for view operations)',
        required: false,
        type: 'string',
      },
      maxRows: {
        toolParamName: 'max_rows',
        description: 'Maximum number of rows to return for read operations (0 = all)',
        required: false,
        type: 'number',
      },
      data: {
        toolParamName: 'data',
        description: 'JSON data for insert/update operations',
        required: false,
        type: 'object',
      },
      filter: {
        toolParamName: 'filter',
        description: 'Filter conditions for update/delete operations',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      data: 'The retrieved or affected data',
      metadata: 'Operation metadata including counts and status',
      taskId: 'Task ID for async bulk operations',
    },
  },
};

export default definition;
